import { render } from "./newly-awarded.vue?vue&type=template&id=a0e21fe2"
import script from "./newly-awarded.vue?vue&type=script&lang=js"
export * from "./newly-awarded.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__